import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../../api/index';
import { Switch, Toast } from 'antd-mobile-v5';
import QRCode from 'qrcode.react';
import { withRouter } from 'react-router-dom';
import styles from './index.module.scss';
import doctor_avatar from '../../../static/images_cso/doctor_avatar.png';
import plz_bind from '../../../static/images_cso/plz_bind.png';
import utils from '../../../utils/utils';

const api = new ApiCore();
const env = process.env.REACT_APP_ENV;

const CSOPatient = (props: any) => {

    const [wxUrl, setWxUrl] = useState('');
    const [doctorInfo, setDoctorInfo] = useState<any>({});
    const [flowCode, setFlowCode] = useState<any>('');

    useEffect(() => {
        document.title = '我的二维码';
        initData();
        return () => {
        }
    }, [])

    const initData = () => {
        let doctor_info = sessionStorage.getItem('cso_doctor_info') || '';
        const projectCode = utils.getUrlParams()?.projectCode || ''
        const doctorInfo: any = JSON.parse(doctor_info);
        setDoctorInfo(doctorInfo);
        api.getDoctorFlowGenerate({
            context: {
                doctorCode: doctorInfo.code,
                projectCode: projectCode,
            },
            type: 'InvitePatient' // InvitePatient -> 绑定患者, DrugOrder -> 买药 
        }).then((result: any) => {
            if (result.code == 0) {
                const _flowCode = result.data || '';
                setFlowCode(result.data);
                let jumpUrl = '';
                if (env === 'production') {
                    // 生产环境用普通链接（只对生产有效）
                    jumpUrl = `https://edc-saas.huimeihealth.com.cn/urllink/cso/patient?flowCode=${_flowCode}&flowType=InvitePatient&tenantCode=${localStorage.getItem('tenantCode') || ''}`;
                    setWxUrl(jumpUrl);
                } else {
                    // jumpUrl = `https://edc-saas-test.huimeimt.com/urllink/cso/patient?flowCode=${_flowCode}`;
                    // 测试环境生成urlLink
                    getWxMiniProgramUrl(_flowCode);
                }
            }
        })
    }

    const getWxMiniProgramUrl = (flowCode: string) => {
        let doctor_info = sessionStorage.getItem('cso_doctor_info') || '{}';
        const doctorInfo: any = JSON.parse(doctor_info);
        return new Promise<void>((resolve) => {
            let envVersion = 'release';
            // 开发环境 开发版
            if (env === 'development') {
                envVersion = 'trial'; // develop
            }
            // 测试环境 体验版
            else if (env === 'test') {
                envVersion = 'trial';
            }
            // 生产环境 正式版
            else if (env === 'production') {
                envVersion = 'release';
            }
            api.apiAppSecretGenerateUrl({// getAppSecretScheme
                appCode: 'CSO_PT',
                envVersion: envVersion,
                path: 'pages/index/index',
                query: `flowCode=${flowCode}&doctorCode=${doctorInfo.code}&flowType=InvitePatient&tenantCode=${localStorage.getItem('tenantCode') || ''}`,
            }).then((res: any) => {
                if (res.code == 0) {
                    let _data = res.data || '';
                    setWxUrl(_data);
                }
                resolve();
            });
        });
    }
    
    return (
        <div className={styles.CSO_doctor_info}>
            <div className={styles.gap}>
                <img src={plz_bind} alt="" />
            </div>
            {/* <div className={styles.qr_card_wrap}> */}
                <div className={styles.qr_card}>
                    {/* <div className={styles.top_wrap}> */}
                    <div className={styles.top}>
                        <img className={styles.doctor_avatar} src={doctor_avatar} alt="" />
                        <div className={styles.top_r}>
                            <div className={styles.top_r_t}>
                                <div>{doctorInfo.name}</div>
                                <div>{doctorInfo.title}</div>
                            </div>
                            <div className={styles.top_r_b}>
                                <div className={styles.c_b_l}>{doctorInfo.institution}</div>
                                {
                                    doctorInfo.dept &&
                                    <>
                                        <div className={styles.vertical_line}></div> 
                                        <div className={styles.c_b_r}>{doctorInfo.dept}</div>
                                    </>
                                }

                            </div>
                        </div>
                    </div>
                    <div className={styles.bottom}>
                        {
                            wxUrl && 
                            <QRCode
                                id="queue_qr"
                                className={styles.qr_code_img_content}
                                value={wxUrl}  //value参数为生成二维码的链接
                                size={161} //二维码的宽高尺寸
                                fgColor="#000000"  //二维码的颜色
                            />
                        }

                    </div>
                    {/* <div className={styles.bottom}>
                    </div> */}
                {/* </div> */}
                </div>
            {/* </div> */}
            <div className={styles.bottom_tip}>
            </div>
        </div>
    )
}

export default withRouter(CSOPatient);